// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4ffc0274","767":"2bff353b"}[chunkId] + ".chunk.js";
};